
import { Component, Vue, Watch } from "vue-property-decorator";
import {
    apiSetMealDetail,
    apiOrderMealAdd,
    apiOrderMealEdit,
    apiMealModule,
} from "@/api/shop";
import { throttle } from "@/utils/util";
import config from "@/config";
@Component
export default class SetMealEdit extends Vue {
    /** S Data **/

    identity: number | null = null; // 当前编辑用户的身份ID

    // 添加商城表单数据
    form: any = {
        number: "", //
        price: "",
        status: 1,
        sort: "",
    };

    // 表单校验
    rules = {
        number: [{ required: true, message: "请输入订单数", trigger: "blur" }],
        price: [{ required: true, message: "请输入订单单价", trigger: "blur" }],
    };

    /** E Data **/

    /** S Methods **/

    // 点击表单提交
    onSubmit(formName: string) {
        // 验证表单格式是否正确
        const refs = this.$refs[formName] as HTMLFormElement;
        refs.validate((valid: boolean): any => {
            if (!valid) return;

            if (!this.identity) {
                this.handleSetMealAdd();
            } else {
                this.handleSetMealEdit();
            }
        });
    }

    // 添加商城
    async handleSetMealAdd(): Promise<void> {
        await apiOrderMealAdd({ ...this.form });
        setTimeout(() => this.$router.go(-1), 500);
    }

    // 编辑商城
    async handleSetMealEdit(): Promise<void> {
        await apiOrderMealEdit({ ...this.form, id: this.identity });
        setTimeout(() => this.$router.go(-1), 500);
    }

    // 获取详情
    async getSetMealDetailFunc(): Promise<void> {
        const res: any = await apiSetMealDetail({
            id: this.identity as number,
        });
        Object.keys(res).map((key) => {
            if (res[key] === null || res[key] === undefined) return;
            this.$set(this.form, key, res[key]);
        });
        console.log(this.form);
    }

    selectModule(menu: any) {
        if (menu.is_required) return;
        const index = this.form.func.findIndex(
            (item: string) => item == menu.en_name
        );
        if (index != -1) {
            this.form.func.splice(index, 1);
            return;
        }
        this.form.func.push(menu.en_name);
    }
    /** E Methods **/

    /** S Life Cycle **/
    async created() {
        const query: any = this.$route.query;

        // 编辑模式：初始化数据
        this.identity = +query.id;
        if (+query.id) {
            await this.getSetMealDetailFunc();
        }
        this.onSubmit = throttle(this.onSubmit, 1000);
    }
    /** E Life Cycle **/
}
